import React, { useEffect, useState } from "react";
import InfoTable from "./InfoTable";
import InfoTab from "./InfoTab";
import { loadStyles } from "../../../utils/cssLoader";

const InfoPage = ({
  data,
  loadCSS,
  dataClient = false,
  baseUrl,
  websiteBaseUrl,
  dataPath,
  isResult = false,
  title,
  id,
  matchType = "league",
  sport,
  difference,
}) => {
  const [clientData, setClientData] = useState(null);
  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);
  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("leagueInfo");
    }
  }, [loadCSS]);

  const sourceData = dataClient ? clientData : data;

  const { data: { upcoming = [], last = [] } = [] } = sourceData || {};

  const table = sourceData?.data?.table || {};
  return (
    <>
      {title && <h1>{title}</h1>}

      <InfoTab
        id={id}
        response={{ upcoming, last }}
        baseUrl={baseUrl}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        matchType={matchType}
        dataClient={dataClient}
        sport={sport}
        difference={difference}
      >
        {table && <InfoTable tableData={table} />}
      </InfoTab>
    </>
  );
};

export default InfoPage;
